import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

const LABEL = {
  retenido_sin_liquidacion: "Retenido sin liquidación",
  reembolso_sin_cerrar: "Reembolso sin cerrar (+3 días)",
  liquidacion_duplicada: "Liquidación duplicada",
  reembolso_duplicado: "Reembolso registrado 2 veces",
  liquidacion_fallida: "Liquidación fallida",
  reembolso_no_cuadra_total: "Reembolso no cuadra con el total",
};

export function LedgerIntegrityPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const load = () => { setLoading(true); api.get("/admin/ledger/integrity").then((r) => setData(r.data)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);
  return (
    <div data-testid="ledger-integrity-panel">
      <div className="flex items-center gap-3 mb-1">
        <h2 className="text-xl font-semibold">Descuadres contables</h2>
        <Button size="sm" variant="outline" onClick={load} disabled={loading} data-testid="ledger-integrity-refresh">{loading ? "Revisando…" : "Volver a revisar"}</Button>
      </div>
      <p className="text-xs text-neutral-500 mb-4">Solo lectura: lista pedidos con la plata descuadrada. Aquí no se corrige ni se mueve dinero.</p>
      {data && (
        <>
          <div className="flex flex-wrap gap-2 mb-4" data-testid="ledger-integrity-counts">
            <span className="text-sm px-3 py-1 rounded bg-neutral-800">Total: <b data-testid="ledger-integrity-total">{data.total}</b></span>
            {Object.entries(data.counts).map(([k, n]) => <span key={k} className="text-sm px-3 py-1 rounded bg-red-500/15 text-red-300">{LABEL[k] || k}: <b>{n}</b></span>)}
          </div>
          {!data.total && <div className="text-sm text-emerald-400" data-testid="ledger-integrity-ok">No hay pedidos descuadrados.</div>}
          <div className="overflow-x-auto">
            <table className="w-full text-xs">
              <tbody>
                {data.rows.map((o) => (
                  <tr key={o.id} className="border-b border-neutral-800" data-testid={`ledger-integrity-row-${o.id}`}>
                    <td className="py-2 pr-3 font-mono">#{o.id.slice(0, 8)}</td>
                    <td className="pr-3">${Number(o.total || 0).toFixed(2)}</td>
                    <td className="pr-3">{o.status}</td>
                    <td className="pr-3 text-neutral-400">{o.payment_method || "—"}</td>
                    <td className="pr-3 text-neutral-500">{(o.created_at || "").slice(0, 10)}</td>
                    <td className="pr-3">{o.problems.map((p) => LABEL[p] || p).join(" · ")}</td>
                    <td className="text-neutral-500">liq. {o.settlements} · reemb. {o.refund_movements}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
